import { Form } from "antd";
import { useParams } from "react-router";

import { CapKeysTable } from "src/app/features/EmvKernelProfile/subFeatures/CapKey/components/tables/CapKeysTable";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const EmvKernelProfilesCaPublicKeysTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <CapKeysTable key={field.name} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
